import { HaftpflichtSchadenKfz } from '@gsm/entities';
import { DYNAMIC_FORM_CONTROL_TYPE_GROUP } from '@ng-dynamic-forms/core';
import { MATCH_COMPARE_WITH_HIDDEN } from '../../matchers/compare-with-visible.matcher';
import { TYPE_DOKUMENTEN_ANGABE } from '../dokumenten-angabe/dokumenten-angabe.model';
import { TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX } from '../geschaedigte-geraete-komplex/geschaedigte-geraete-komplex.model';
import { TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON } from '../haftpflicht-geschaedigte-person/haftpflicht-geschaedigte-person.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';
import { HaftpflichtAdditional, HaftpflichtSchadenVorhanden } from '../shared-models/haftpflichtschaden.model';

const GESCHAEDIGTE_PERSON_RELATION = {
  match: MATCH_COMPARE_WITH_HIDDEN,
  when:  [
    {
      id:          'geschaedigtePerson',
      compareWith: val => !val?.vorhanden || val.vorhanden === HaftpflichtSchadenVorhanden.Nachgebracht
    }
  ]
};

export function HAFTPFLICHT_SACHSCHADEN_HANDY_TEMPLATE(
  value: HaftpflichtSchadenKfz,
  modelValue,
  fieldId: string,
  {
    docTypBelege,
    geschPersList,
    kundeList,
    updateClaim,
    paperProcessOverride
  }: HaftpflichtAdditional = {},
  isEditEvent = false
): AnyFormControlModel[] {
  const {
    id,
    vorhanden,
    geschaedigtePerson,
    belege = []
  } = value || {};

  if (!isEditEvent && geschPersList && modelValue.length) {
    // only persons who are not in the local modelValue
    geschPersList = geschPersList.filter(
      geschPers => !modelValue.some(val => val.geschaedigtePerson?.correlationId === geschPers.correlationId)
    );
  }

  return [
    {
      id:         'geschaedigtePerson',
      type:       TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON,
      value:      {
        id,
        vorhanden,
        geschaedigtePerson
      },
      additional: {
        geschPersList,
        updateClaim,
        paperProcessOverride,
        detailsNachbringen:
          !!geschaedigtePerson?.geschaedigtesGeraetList?.some(geraet => geraet.status === 'N') ||
          !!geschaedigtePerson?.geschaedigtesHaushaltsgeraetList?.some(geraet => geraet.status === 'N')
      }
    },
    {
      id:        'geschaedigtesGeraetList_group',
      type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
      label:     'Beschädigte Geräte/Sache angeben',
      hidden:    true,
      relations: [GESCHAEDIGTE_PERSON_RELATION],
      group:     [
        {
          id:         'geschaedigtesGeraetList',
          type:       TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX,
          required:   true,
          additional: {
            updateClaim
          },
          value:
                      fieldId === 'KERN_HAFTPFLICHT_FF_haushaltsgeraeteschaeden'
                        ? geschaedigtePerson?.geschaedigtesHaushaltsgeraetList
                        : geschaedigtePerson?.geschaedigtesGeraetList
        }
      ]
    },
    {
      id:        'aufstellungBelege_group',
      type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
      label:     'Belege für Neukauf oder Reparatur',
      hidden:    true,
      relations: [GESCHAEDIGTE_PERSON_RELATION],
      group:     [
        {
          id:         'aufstellungBelege',
          type:       TYPE_DOKUMENTEN_ANGABE,
          additional: {
            optionalTypes:       docTypBelege,
            kunden:              kundeList,
            immediateValidation: true
          },
          value:      belege
        }
      ]
    }
  ];
}
